import { render, staticRenderFns } from "./TenantNotificationSetting.vue?vue&type=template&id=c409c140&scoped=true"
import script from "./TenantNotificationSetting.vue?vue&type=script&lang=js"
export * from "./TenantNotificationSetting.vue?vue&type=script&lang=js"
import style0 from "./TenantNotificationSetting.vue?vue&type=style&index=0&id=c409c140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c409c140",
  null
  
)

export default component.exports